import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./index.css"
import "bootstrap/dist/css/bootstrap.css"
import { Provider } from "react-redux"
import { basicReduxStore } from "./reduxStore"

ReactDOM.render(
  <Provider store={basicReduxStore}>
    <App />
  </Provider>,
  document.getElementById("root")
)
